"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTrackedFormikFieldComponent = exports.createFieldComponent = exports.TrackedFormikInput = exports.InputField = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _analytics = require("../common/analytics");

var _Input = _interopRequireDefault(require("angieslist-react-components/lib/Input"));

var _Formik = _interopRequireDefault(require("angieslist-react-components/lib/Formik"));

var _excluded = ["meta", "id", "input", "children"];

var createFieldComponent = function createFieldComponent(Component) {
  return function (field) {
    var _field$meta = field.meta,
        meta = _field$meta === void 0 ? {} : _field$meta,
        id = field.id,
        input = field.input,
        children = field.children,
        otherProps = (0, _objectWithoutProperties2.default)(field, _excluded);
    return /*#__PURE__*/(0, _jsx2.default)(_analytics.Track, {}, void 0, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      id: id
    }, otherProps, input, {
      touched: meta.touched,
      error: meta.error,
      help: meta.touched && meta.error || otherProps.help,
      bsStyle: (meta.touched && meta.error ? 'error' : undefined) || otherProps.bsStyle
    }), children));
  };
};

exports.createFieldComponent = createFieldComponent;
var InputField = createFieldComponent(_Input.default);
exports.InputField = InputField;

var createTrackedFormikFieldComponent = function createTrackedFormikFieldComponent(Component) {
  return _Formik.default.createFormikFieldComponent(Component, _analytics.Track);
};

exports.createTrackedFormikFieldComponent = createTrackedFormikFieldComponent;
var TrackedFormikInput = createTrackedFormikFieldComponent(_Input.default);
exports.TrackedFormikInput = TrackedFormikInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/forms.js
// module id = 118
// module chunks = 25